module.exports = __webpack_public_path__ + "static/media/galdinsWon_2500_5000.2f572dd7.png";